// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"120fcbe0","312":"294056c8","592":"567f549e"}[chunkId] + ".chunk.js";
};